export default __webpack_public_path__ + "static/media/llamada_SPDP_incoming_call.3501b310.mp3";